// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkComponent_link__2UXxJ","icon":"LinkComponent_icon__2JA6v"};